import { For, Show } from 'solid-js';
import ItemStackView from './ItemStackView';
import { useCraftingResolver } from '../services/craftingResolverContext';
import { resolveItemDisplayName } from '../services/itemDisplayName';
import { formatQuantity } from '../services/quantityFormatter';
import type { SellbotReasonItem } from '../services/sellbotReasonItems';

interface SellbotReasonItemsProps {
    items: SellbotReasonItem[];
    size?: number;
    showNames?: boolean;
}

export default function SellbotReasonItems(props: SellbotReasonItemsProps) {
    const resolver = useCraftingResolver();

    const itemLabel = (entry: SellbotReasonItem) =>
        resolveItemDisplayName(entry.stack, resolver());

    return (
        <Show when={props.showNames !== false} fallback={
            <span class="h hcenter" style={{ gap: 'var(--spacing-xs)', 'flex-wrap': 'wrap' }}>
                <For each={props.items}>{(entry) => (
                    <ItemStackView stack={entry.stack} size={props.size ?? 20} showTooltip showCount={false} />
                )}</For>
            </span>
        }>
            <div class="v" style={{ gap: 'var(--spacing-xs)' }}>
                <For each={props.items}>{(entry) => (
                    <span class="h hcenter" style={{ gap: 'var(--spacing-sm)' }}>
                        <ItemStackView stack={entry.stack} size={props.size} showTooltip showCount={false} />
                        <span>{itemLabel(entry)} ×{formatQuantity(entry.count, resolver()?.getItem(entry.itemKey)?.stackSize)}</span>
                    </span>
                )}</For>
            </div>
        </Show>
    );
}
